import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Rota raiz autenticada: redireciona pro dashboard.
 */
export const Route = createFileRoute('/pep-vida/_authed/')({
  component: IndexRedirect,
});

function IndexRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    navigate({ to: '/pep-vida/dashboard' });
  }, [navigate]);
  return null;
}
